<h1>Albion Online Map</h1>
<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" animationDuration="100" (selectedTabChange)="onTabChange($event)">
  <!-- MARK: Intro -->
  <mat-tab label="Intro">
    <app-intro-container>
      <app-section sectionTitle="FEATURE HIGHLIGHTS">
        <div class="features-grid">
          <app-feature featureTitle="Interactive Overlays">
            <p>
              Dynamic regional overlays rendered from game data showing PvP zones, territory types, and connections. Each zone is color-coded based on its PvP
              status for quick visual reference.
            </p>
          </app-feature>
          <app-feature featureTitle="Weighted Pathfinding">
            <p>
              Smart pathfinding algorithm that calculates optimal routes based on your preferences. Customize weights for different PvP zones (blue, yellow,
              red, black) and map categories (roads, passages, etc.) to find safer or faster routes.
            </p>
          </app-feature>
          <app-feature featureTitle="Smart Markers">
            <p>
              Interactive markers for all exits and portals, clearly indicating connections between zones. Click markers to set start and end points for route
              calculation, with clear visual feedback for selected points.
            </p>
          </app-feature>
          <app-feature featureTitle="Detailed Journey Summary">
            <p>
              Comprehensive route analysis showing total distance, estimated travel time, and breakdown by zone types. View step-by-step directions and analyze
              time spent in different PvP zones to better plan your journey.
            </p>
          </app-feature>
        </div>
      </app-section>
      <app-section sectionTitle="HOW TO USE">
        <p>
          Start by clicking a marker on the map to set your origin. Then select a destination marker to compute and display the optimal path based on your
          configured weights. Adjust your settings under the "Settings" tab to customize portal preferences and zone weightings.
        </p>
        <p>
          A higher weight value increases the likelihood of the pathfinder avoiding that zone or category. For example, setting a high weight for "Red Zone"
          will make the pathfinder prefer safer routes through blue or yellow zones when possible.
        </p>
        <p>
          Once a route is calculated, switch to the "Summary" tab to view detailed statistics about your journey. The summary includes total distance, estimated
          travel time, and a breakdown of the route by PvP zones and map types. This information helps you evaluate the safety and efficiency of different route
          options.
        </p>
      </app-section>
    </app-intro-container>
  </mat-tab>
  <!-- MARK: Settings -->
  <mat-tab label="Settings">
    @defer (on viewport) {
      <app-map-settings [mapComponent]="mapComponent"></app-map-settings>
    } @placeholder {
      <p>Settings</p>
    }
  </mat-tab>
  <!-- MARK: Map -->
  <mat-tab label="Map">
    @defer (on viewport) {
      <div class="map-container">
        <div class="map-frame">
          <app-map #map></app-map>
        </div>
      </div>
    } @placeholder {
      <p>Map</p>
    }
  </mat-tab>
  <!-- MARK: Summary -->
  <mat-tab label="Summary" [disabled]="!mapComponent?.path()?.length">
    @defer (on viewport) {
      <app-map-summary [mapComponent]="mapComponent"></app-map-summary>
    } @placeholder {
      <p>Summary</p>
    }
  </mat-tab>
</mat-tab-group>
